import { useMemo } from 'react'
import {
  Dialog, DialogHeader, DialogBody, DialogFooter,
  Button, Chip, Typography
} from '@material-tailwind/react'

const fmt = (d) => (d ? new Date(d).toLocaleString() : '—')
const kindLabel = (kind) => {
  const k = String(kind || '').toLowerCase()
  if (k === 'entry') return 'Entrada'
  if (k === 'exit') return 'Salida'
  return k
}

export function UsageLogModal({ open, onClose, usage, title = 'Registro de uso', visitor }) {
  // usage: { version, events: [...], stats: {...} }
  const { events, stats } = useMemo(() => {
    const data = usage && typeof usage === 'object' ? usage : {}
    const evts = Array.isArray(data.events) ? data.events.slice() : []
    // Orden cronológico
    evts.sort((a, b) => new Date(a.at || 0) - new Date(b.at || 0))
    const st = (data.stats && typeof data.stats === 'object') ? data.stats : {}
    return { events: evts, stats: st }
  }, [usage])

  const name  = visitor?.name || '—'
  const doc   = visitor?.document_number || '—'
  const email = visitor?.email || '—'

  return (
    <Dialog open={open} handler={onClose} size="md">
      <DialogHeader>{title}</DialogHeader>
      <DialogBody divider className="max-h-[70vh] overflow-y-auto">
        <div className="rounded-lg border border-gray-200 bg-white p-3 mb-3">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <p className="text-[11px] uppercase tracking-wide text-gray-500">Nombre</p>
              <p className="text-sm font-medium text-gray-900 break-words">{name}</p>
            </div>
            <div>
              <p className="text-[11px] uppercase tracking-wide text-gray-500">Doc. de Identidad</p>
              <p className="text-sm font-medium text-gray-900 break-words">{doc}</p>
            </div>
            <div>
              <p className="text-[11px] uppercase tracking-wide text-gray-500">Correo Electrónico</p>
              <p className="text-sm font-medium text-gray-900 break-words">{email}</p>
            </div>
          </div>
        </div>

        {!events || events.length === 0 ? (
          <div className="text-gray-600">No hay eventos registrados.</div>
        ) : (
          <div className="space-y-3">
            {/* Chips de resumen */}
            <div className="flex flex-wrap gap-2 items-center sticky top-0 bg-white py-2 z-10">
              <Chip
                value={`Entradas: ${stats.entries ?? 0}`}
                size="sm"
                color="green"
                className="rounded-full"
              />
              <Chip
                value={`Salidas: ${stats.exits ?? 0}`}
                size="sm"
                color="blue-gray"
                className="rounded-full"
              />
              {stats.last_event?.kind && (
                <Chip
                  value={`Último: ${kindLabel(stats.last_event.kind)} · ${fmt(stats.last_event.at)}`}
                  size="sm"
                  color="amber"
                  className="rounded-full font-semibold"
                />
              )}
            </div>

            {/* Lista de eventos */}
            <ul className="divide-y divide-gray-200 rounded-lg border border-gray-200 bg-white">
              {events.map((e) => {
                const kind = String(e.kind || '').toLowerCase()
                const color = kind === 'entry'
                  ? 'green'
                  : kind === 'exit'
                    ? 'blue-gray'
                    : 'gray'
                const user = e.by_user || {}

                return (
                  <li key={e.id || `${e.kind}-${e.at}`} className="p-3">
                    <div className="flex items-center justify-between gap-2">
                      <div className="flex items-center gap-2">
                        <Chip value={kindLabel(kind)} size="sm" color={color} />
                        <Typography variant="small" className="text-gray-800">
                          {fmt(e.at)}
                        </Typography>
                      </div>
                      {typeof e.meta?.pistol === 'boolean' && (
                        <Chip
                          value={e.meta.pistol ? 'Pistola' : 'Manual'}
                          size="sm"
                          color={e.meta.pistol ? 'indigo' : 'gray'}
                        />
                      )}
                    </div>

                    <div className="mt-1 grid grid-cols-1 gap-y-1">
                      <p className="text-xs text-gray-600 truncate">
                        <span className="font-medium">Usuario:</span>{' '}
                        {user.name || user.email || user.id || '—'}
                      </p>
                      {e.meta?.observations && (
                        <p className="text-xs text-gray-600">
                          <span className="font-medium">Observaciones:</span>{' '}
                          {e.meta.observations}
                        </p>
                      )}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </DialogBody>
      <DialogFooter>
        <Button variant="text" onClick={onClose}>Cerrar</Button>
      </DialogFooter>
    </Dialog>
  )
}